<!-- 2 columns form -->
<form name="branchform" [formGroup]="branchForm" novalidate>
  <div class="panel panel-flat">
    <div class="panel-heading">
      <h5 class="panel-title">Add Branch</h5>
      <div class="heading-elements">
        <ul class="icons-list">
          <li>
            <a data-action="reload" ng-click="mainService.reload()"></a>
          </li>
        </ul>
      </div>
      <hr class="divider">
    </div>

    <div class="panel-body">

      <div class="row">
        <div class="col-md-5">
          <fieldset>
            <legend class="text-semibold">
              <i class="icon-reading position-left"></i> Branch Details
            </legend>


            <div class="row">


              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Name: </span>

                  <input type="text" name="name" formControlName="name" placeholder="branch name" class="form-control">
                  <div class="help-block" *ngIf="name.invalid && (name.dirty || name.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> Branch Name is required
                    </p>
                  </div>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Region: </span>
                  <ng-select [items]="regions" placeholder="" formControlName="region" bindValue="value"
                    bindLabel="name" required>
                  </ng-select>
                  <div class="help-block" *ngIf="region.invalid && (region.dirty || region.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> Region is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">City: </span>
                  <br>
                  <br>
                  <input type="text" name="city" formControlName="city" placeholder="branch city" class="form-control">
                  <div class="help-block" *ngIf="city.invalid && (city.dirty || city.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> Branch Date is required
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">

              <div class="col-md-6">
                <div class="form-group">
                  <span class="control-label">Subcity: </span>
                  <input type="text" name="sub_city" formControlName="sub_city" placeholder="sub city" class="form-control">
                </div>
              </div>


              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Woreda/Kebele: </span>
                  <input type="text" name="woreda_kebele" required formControlName="woreda_kebele"
                    placeholder="Woreda/Kebele" class="form-control">
                  <div class="help-block"
                    *ngIf="woreda_kebele.invalid && (woreda_kebele.dirty || woreda_kebele.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> Woreda/kebele is required
                    </p>
                  </div>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label"> House Number: </span>
                  <input type="text" name="house_no" formControlName="house_no" placeholder="House number"
                    class="form-control" required>
                  <div class="help-block" *ngIf="house_no.invalid && (house_no.dirty || house_no.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 tx-red position-left"></i> House Number is required
                    </p>
                  </div>
                </div>
              </div>



              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Email: </span>
                  <input type="text" name="email" formControlName="email" placeholder="Email Address"
                    class="form-control" required>
                  <div class="help-block" *ngIf="email.invalid && (email.dirty || email.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Email is required
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Primary Phone Number: </span>
                  <input type="text" name="phone_number_1" formControlName="phone_number_1"
                    placeholder="Primary phone number" class="form-control" required>
                  <div class="help-block"
                    *ngIf="phone_number_1.invalid && (phone_number_1.dirty || phone_number_1.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Primary phone number is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Secondary Number: </span>
                  <input type="text" name="phone_number_2" formControlName="phone_number_2"
                    placeholder="Secondary phone number" class="form-control" required>
                  <div class="help-block"
                    *ngIf="phone_number_2.invalid && (phone_number_2.dirty || phone_number_2.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Secondary phone number is required
                    </p>
                  </div>
                </div>
              </div>


            </div>

          </fieldset>
        </div>

        <div class="col-md-7">
          <fieldset>
            <legend class="text-semibold">
              <i class="icon-camera position-left"></i> Branch Details
            </legend>


            <div class="row">

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Contact Person: </span>
                  <input type="text" name="contact_person" formControlName="contact_person" placeholder="Contact Person"
                    class="form-control" required>
                  <div class="help-block"
                    *ngIf="contact_person.invalid && (contact_person.dirty || contact_person.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Contact person is required
                    </p>
                  </div>
                </div>
              </div>


              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Status: </span>
                  <select name="status" required formControlName="status" class="form-control"
                    data-placeholder="Select branch status">
                    <option selected disabled>Status:</option>
                    <option value="pending">Pending</option>
                    <option value="active">Active</option>
                    <option value="closed">Closed</option>
                  </select>
                  <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Branch status is required.
                    </p>
                  </div>
                </div>
              </div>


              <div class="col-md-12">
                <div class="form-group required">
                  <span class="control-label">Specific Location: </span>
                  <input type="text" name="specific_location" formControlName="specific_location"
                    placeholder="Contact Person" class="form-control" required>
                  <div class="help-block"
                    *ngIf="specific_location.invalid && (specific_location.dirty || specific_location.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Contact person is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label>&nbsp;</label>
                  <label>Remark:</label>
                  <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                    placeholder="Additional information . . ." required></textarea>
                  <div class="help-block" *ngIf="remark.invalid && (remark.dirty || remark.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Please write small description about the
                      branch
                    </p>
                  </div>
                </div>
              </div>

            </div>

          </fieldset>
        </div>

      </div>

      <div class="text-right">

        <!--  <button class="btn bg-slate-800" (click)="addNews(branch.id)" type="submit" data-style="slide-right" [ladda]="isLoading" [disabled]="newsForm.invalid">
          <span *ngIf="!branch.id">Save News</span>
          <span *ngIf="branch.id">Update News</span>
          <i class="icon-floppy-disk position-right"></i>
        </button> -->
        <button class="btn bg-slate-800" (click)="addBranch()" type="submit" data-style="slide-right"
          [disabled]="branchForm.invalid">
          <span *ngIf="operation=='add'">Save Branch</span>
          <span *ngIf="operation!='add'">Update Branch</span>
          <i class="icon-floppy-disk position-right"></i>
        </button>
      </div>

    </div>
  </div>
</form>
<!-- /2 columns form -->